export const GLOBAL = {
    apiUrl: 'http://promo.serpent.com/back/web/api/',
    url: 'http://promo.serpent.com/back/web/'
};
